/** One 1-based page of an already-filtered list, for tables paged client-side. */
export const paginate = (rows, page, pageSize) => {
  const safePage = Math.max(1, Number(page) || 1);
  const start = (safePage - 1) * pageSize;

  return rows.slice(start, start + pageSize);
};
